import {useEffect, useState} from "react";
import {baseApi} from "../../api/axios";
import LoadingComponent from "../Loading/LoadingComponent";
import {useAuthStore} from "../../store/user-store";
import {toast} from "react-toastify";

export default function BanksList() {

    const [loading, setLoading] = useState(false)
    const [loadingSubmit, setLoadingSubmit] = useState(false)
    const [errorImage, setErrorImage] = useState('')
    const [errorAmount, setErrorAmount] = useState('')
    const [errorTransactionId, setErrorTransactionId] = useState('')
    const [banks, setBanks] = useState([])
    const [bank, setBank] = useState({})
    const [transactionId, setTransactionId] = useState('')
    const [amount, setAmount] = useState(0)
    const [image, setImage] = useState(0)
    const [imagePreview, setImagePreview] = useState(null);
    const authStore = useAuthStore();
    const onSubmit = async () => {
        setLoadingSubmit(true)
        if (!image) {
            setErrorImage('يرجى تحديد صورة الإشعار')
            setLoadingSubmit(false)
            return;
        }

        if (parseFloat(amount) <= 0) {
            setErrorAmount('يرجى إدخال القيمة')
            setLoadingSubmit(false)
            return;
        }
        if(bank?.type?.length>0 && transactionId==''){
            setErrorTransactionId('يرجى إدخال رقم الحوالة')
            setLoadingSubmit(false)
            return;
        }

        const formData = new FormData();
        formData.append('amount', amount);
        formData.append('transaction_id', transactionId);
        formData.append('img', image);
        formData.append('bank_id', bank?.id);
        try {
            var response = await baseApi.post('/charges', formData);
            if (response?.status === 200) {
                if(bank?.type?.length>0){
                    toast.success('جاري مراجعة طلبك سيتم الشحن بشكل مباشر');
                }else{
                    toast.success('تم إرسال الطلب بنجاح');
                }

            }
        } catch (e) {

            toast.error(e.response?.data?.msg)
        }
        setLoadingSubmit(false)
    }
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage(file);
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            setImage(null);
            setImagePreview(null);
        }
    }


    useEffect(() => {
        getBanks()
    }, [])

    const getBanks = async () => {
        setLoading(true)
        try {
            var res = await baseApi('/banks');

            if (res.data?.banks != null) {
                setBanks(res.data?.banks)
            }
            console.log(res.data);
        } catch (e) {

        }
        setLoading(false)
    }

    return <div className={'container'}>
        <div className="row justify-content-center">
            <div className="col-md-4 border border-white border-1 p-3 text-center">
                {loading === false && banks.length === 0 ?
                    <h3 className={'alert alert-danger'}>لا يوجد طرق دفع</h3> : null}
                {loading === true ? <LoadingComponent/> : null}
                <div className="banks-list">

                    {banks.length > 0 ? banks.map((b) => {
                        return (
                            <div key={b.id} onClick={() =>{
                                if(bank?.id!=b?.id) {
                                    setBank(b)
                                    setTransactionId('')
                                }
                            }}
                                 className={`d-flex flex-column justify-content-center align-items-center bank m-2 ${bank?.id === b.id ? 'active' : ''}`}>
                                <img className={'img-bank'} src={`${b.img}`} alt=""/>
                                <span className={'title-bank'}>{b.name}</span>
                            </div>
                        )
                    }) : null}


                </div>
            </div>
            <div className="col-md-8 p-2">
                {bank?.id == null ? <h3 className={'alert alert-warning'}>يرجى تحديد طريقة دفع</h3> : null}
                {
                    bank?.id != null ? <div className={'text-center'}>
                            <h3 className={'text-white text-center'}>{bank?.name}</h3>
                            <p className={'text-black text-center bank-info bg-white p-2'}>{bank?.info}
                                <br/>
                                <span>رقم الحساب : </span>
                                <span className={'text-danger'}>{bank?.iban}</span> <i className="fa fa-copy fa-lg mx-2"
                                                                                       onClick={() => authStore.copyText(bank?.iban)}/>

                            </p>
                            <div className="d-flex flex-column justify-content-center align-items-center">
                                <div className="form-group">
                                    <label htmlFor="" className={'text-white'}>القيمة</label>
                                    <input type="text" onChange={(e) => setAmount(e.target.value)}
                                           className="input-form my-2  m-auto" placeholder={'القيمة'} autoComplete={'off'}
                                           value={amount}/>
                                    {errorAmount?.length > 0 ? <span className={'text-danger'}>{errorAmount}</span> : null}
                                </div>
                                {bank.type?.length>0 && (<div className="form-group">
                                    <label htmlFor="" className={'text-white'}>رقم الحوالة</label>
                                    <input type="text" onChange={(e) => setTransactionId(e.target.value)}
                                           className="input-form my-2  m-auto" placeholder={'رقم الحوالة'}
                                           autoComplete={'off'}
                                           value={transactionId}/>
                                    {errorTransactionId?.length > 0 ?
                                        <span className={'text-danger'}>{errorTransactionId}</span> : null}
                                </div>)}

                                <div className="form-group">
                                    <label htmlFor="" className={'text-white'}>صورة الإشعار</label>
                                    <input type="file" onChange={handleImageChange}
                                           className="input-form my-2  m-auto" placeholder={'صورة الإشعار'}
                                           autoComplete={'off'}/>
                                    {errorImage?.length > 0 ?
                                        <span className={'text-danger'}>{errorImage}</span> : null}
                                </div>
                                {imagePreview && (
                                    <div className="image-preview mt-3">
                                        <img src={imagePreview} alt="Preview" style={{maxWidth: '100%'}}/>
                                    </div>
                                )}
                            </div>
                            {!loadingSubmit ?
                                <button onClick={onSubmit} className="btn d-block btn-sm submit-btn m-auto">حفظ</button> :
                                <button className="btn d-block btn-sm submit-btn m-auto">جاري المعالجة</button>}
                        </div>
                        : null
                }
            </div>
        </div>
    </div>
}